export default "__VITE_ASSET__37ae1353__"